import { useContext } from "react";
import NvsAuthorableProductContext from "../components/NVSAuthorableProduct/AuthorableProductProvider";
import { CameraControls } from "@react-three/drei";

export function useCameraControlsRef(): React.RefObject<CameraControls> | null {
  const { cameraControlsRef } = useContext(NvsAuthorableProductContext);
  return cameraControlsRef;
}
